// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aOKW","newExpiryDate":"styles_newExpiryDate__24nwM","footer":"styles_footer__1baKW"};